import React from 'react';
import { FaVideo } from 'react-icons/fa';

interface VideoButtonProps {
  onOpenConvertUrlModal: () => void;
}

export const VideoButton: React.FC<VideoButtonProps> = ({ onOpenConvertUrlModal }) => {
  return (
    <button
      className='toolbar-button'
      onClick={onOpenConvertUrlModal}
      title='動画用URL'
      type='button'
    >
      <FaVideo />
    </button>
  );
};
